import React from 'react';
import { styled } from '@compiled/react';

import { token } from '@atlaskit/tokens';
import { N20A } from '@atlaskit/theme/colors';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const SkeletonWrapper = styled.div({
	display: 'flex',
	height: '39px',
	marginBottom: token('space.150', '12px'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Avatar = styled.div({
	background: token('color.background.neutral', N20A),
	height: '32px',
	width: '32px',
	margin: token('space.025', '2px'),
	marginRight: token('space.150', '12px'),
	borderRadius: '64px',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Action = styled.div({
	background: token('color.background.neutral', N20A),
	width: '168px',
	marginBottom: token('space.075', '6px'),
	height: '14px',
	borderRadius: '7px',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Time = styled.div({
	background: token('color.background.neutral', N20A),
	width: '85px',
	height: '11px',
	borderRadius: '5.5px',
});

export const ActivityLineUpdateDetailSkeleton = () => (
	<SkeletonWrapper data-testid="activity-detail-skeleton">
		<Avatar />
		<div>
			<Action />
			<Time />
		</div>
	</SkeletonWrapper>
);
